import { ReactNode } from 'react';
import Navbar from '../common/Navbar';

interface LayoutProps {
  children: ReactNode;
  user?: any;
  onLogout: () => void;
}

export default function Layout({ children, user, onLogout }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-bg">
      <Navbar user={user} onLogout={onLogout} />
      <main className="container max-w-7xl mx-auto px-4 py-8 pt-24">
        {children}
      </main>
    </div>
  );
}

